import { useEffect, useState } from "react";
import "./themes/cscca-2025/App.css";
import "./styles/animations.css";
import { Login } from "./components/Login";
import Scoreboard from "./components/Scoreboard";
import Loading from "./components/Loading";
import { auth$ } from "./data/auth";

function App() {
  const [isSignedIn, setIsSignedIn] = useState(false);
  const [isAuthLoading, setIsAuthLoading] = useState(true);
  
  useEffect(() => {
    const subscriber = auth$.subscribe((auth) => {
      if (auth) {
        setIsSignedIn(true);
      } else {
        setIsSignedIn(false);
      }
      setIsAuthLoading(false);
    });
    return () => subscriber.unsubscribe();
  }, []);
  
  if (isAuthLoading) {
    return <div className="App"><Loading /></div>;
  }
  
  return <div className="App">{isSignedIn ? <Scoreboard /> : <Login />}</div>;
}

export default App;
